module.exports = __webpack_public_path__ + "static/media/triangle-exclamation.9e77650a.svg";